module.exports = __webpack_public_path__ + "static/media/galerija_2021 (2)-min.c430a5c3.jpg";